import { AdvertisementsService, DeleteAdvertisementData } from "@/client";
import { HttpError } from "@/types/error";
import { UseMutationOptions, useMutation } from "@tanstack/react-query";

function useDeleteAdvertisement(
  mutationOptions?: UseMutationOptions<
    unknown,
    HttpError,
    DeleteAdvertisementData
  >,
) {
  return useMutation({
    mutationFn: AdvertisementsService.deleteAdvertisement,
    ...mutationOptions,
  });
}

export { useDeleteAdvertisement };
